import { Component as ComponentContainer } from '@styles/layout';
import { ContactDetails } from '@components/help';

export const ContactDetailsContainer = () => {
  return (
    <ComponentContainer>
      <ContactDetails />
    </ComponentContainer>
  );
};
